export type LogEntity = string | Record<string, unknown> | Error

export function removeSensitiveData(log: LogEntity): LogEntity {
  function sensitiveDataReplacer(key: string, value: unknown): unknown {
    const sensitiveKeys = ['password', 'token', 'auth', 'secret', 'email', 'username']

    const lowerKey = key.toLowerCase()

    const hasSensitiveData = sensitiveKeys.some((sensitiveKey) => lowerKey.includes(sensitiveKey))

    if (hasSensitiveData) {
      return '__REMOVED__'
    }

    // In some URLs we have a token on the url hash,
    // which should not be tracked for security reasons.
    if (key === 'url' && typeof value === 'string') {
      return value.replace(/#.+/, '__REMOVED__')
    }

    if (value instanceof Error) {
      const plainErrorObject: Record<string, unknown> = {}
      Object.getOwnPropertyNames(value).forEach((prop) => {
        plainErrorObject[prop] = (value as Record<string, unknown> & Error)[prop]
      })
      return plainErrorObject
    }

    return value
  }

  return JSON.parse(
    JSON.stringify(log, (key, value) =>
      typeof value === 'bigint'
        ? sensitiveDataReplacer(key, value.toString())
        : sensitiveDataReplacer(key, value)
    )
  )
}
